import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';

export interface ErrorDialogData {
  title: string;
  message: string;
  details?: string[];
  eventId?: string;
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ClipboardModule,
    MatDialogTitle,
    MatIcon,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIconButton,
  ],
})
export class ErrorDialogComponent {
  protected readonly data = inject<ErrorDialogData>(MAT_DIALOG_DATA);
  private readonly snackBar = inject(MatSnackBar);
  private readonly clipboard = inject<Clipboard>(Clipboard);

  protected copyEventId() {
    if (this.clipboard.copy(this.data.eventId))
      this.snackBar.open('Copied event ID to clipboard', 'Close', { duration: 1000 });
    else
      this.snackBar.open('Unable to copy event ID to clipboard', 'Close', { duration : 5000 });
  }
}
